import { notificationSocketDomain } from '../../util/config';
import { NOTIFICATION_MESSAGES } from './helpers';

export namespace NotificationUtils {
	export const isSocketConnectionReady = (connection: WebSocket) => {
		if (!connection) {
			return false;
		}
		return connection.readyState === 1;
	};

	export const connectToSocketServer = ({
		onOpen,
		onClose,
		onMessage,
		onError,
		accountId,
		mediaId,
	}: {
		accountId: string;
		mediaId: string;
		onOpen?: (_connection: WebSocket) => void;
		onClose?: (_connection: WebSocket) => void;
		onMessage?: (_response: MessageEvent<any>) => void;
		onError?: (_connection: WebSocket) => void;
	}) => {
		const webSocketConnection = notificationSocketDomain && new WebSocket(notificationSocketDomain);
		if (!webSocketConnection) {
			return undefined;
		}

		webSocketConnection.onopen = () => {
			if (NotificationUtils.isSocketConnectionReady(webSocketConnection)) {
				subscribeMessages({ connection: webSocketConnection, accountId, mediaId });
			}
			onOpen?.(webSocketConnection);
		};

		webSocketConnection.onerror = () => {
			if (webSocketConnection && webSocketConnection.close) {
				webSocketConnection.close();
			}
			onError?.(webSocketConnection);
		};

		webSocketConnection.onclose = () => {
			setTimeout(() => {
				if (NotificationUtils.isSocketConnectionReady(webSocketConnection)) {
					return;
				}
				connectToSocketServer({
					onOpen,
					onClose,
					onMessage,
					onError,
					accountId,
					mediaId,
				});
				onClose?.(webSocketConnection);
			}, 1000);
		};

		webSocketConnection.onmessage = (response) => onMessage?.(response);

		return webSocketConnection;
	};

	export const subscribeMessages = ({ accountId, mediaId, connection }: { connection: WebSocket; accountId: string; mediaId: string }) => {
		const messageKeys = Object.keys(NOTIFICATION_MESSAGES).map((key) => 'Subscribe.On.' + (NOTIFICATION_MESSAGES as any)[key]);
		const request = {
			key: '',
			body: {
				filter: {
					tenantId: accountId,
					mediaId: mediaId,
				},
				history: new Date(Date.now()).toISOString(),
			},
		};

		for (let i = 0; i < messageKeys.length; i++) {
			request.key = messageKeys[i];
			connection.send(JSON.stringify(request));
		}
	};
}
